import { useState } from 'react';
const useRerender = () => {
  const [v, setVal] = useState();
  return () => setVal(!v);
};
export default useRerender;